interface INav {
  name: string,
  to: string,
  category: string,
  isExternal?: boolean; // Add isExternal property for external links
}

export const itemsNav: INav[] = [
/** */  {
    name: 'Home',
    to: 'https://ckayb-47be2.web.app/', // Replace with your external URL
    category: '',
    isExternal: false, // Specify isExternal for external links
  },
  {
    name: 'FOTR Louis',
    to: '/',
    category: 'Louis'
  },
  {
    name: 'Fotr Mwenesi',
    to: '/',
    category: 'Mwenesi'
  },
  {
    name: 'FOTR Gina Din',
    to: '/',
    category: 'Gina'
  },
  {
    name: 'LAD Collection',
    to: '/',
    category: 'LAD'
  },
  {
    name: 'FOTR Limited',
    to: '/',
    category: 'Limited'
  },

]
